import { Component, Input, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { AccountResource } from '../api/acount.resource.service';
import { AuthService } from '../api/auth.service';

@Component({
  selector: 'app-create-password',
  templateUrl: './create-password.page.html',
  styleUrls: ['./create-password.page.scss'],
})
export class CreatePasswordPage implements OnInit {

  @Input() canClose: boolean;
  constructor(private service: AccountResource, private authService: AuthService, private navCtrl: NavController, private modalCtrl: ModalController) {

  }

  ngOnInit() {
  }

  savePassword(newPassword, repeatPassword) {
    if (newPassword === repeatPassword)
      this.service.update({ password: newPassword, repeatPassword: repeatPassword }).then(() => {
        this.authService.refreshSession().then(() => {
          this.modalCtrl.dismiss();
          if (!this.canClose) {
            this.navCtrl.navigateRoot(['/main/products']);
          }
        });
      });
  }

  close() {
    this.modalCtrl.dismiss();

  }

}
